<template>
  <v-navigation-drawer
    :value="isAddNewUserSidebarActive"
    temporary
    touchless
    :right="!$vuetify.rtl"
    :width="$vuetify.breakpoint.smAndUp ? 350 : '100%'"
    app
    @input="(val) => $emit('update:is-add-new-class-sidebar-active', val)"
  >
    <v-card height="100%">
      <div class="drawer-header d-flex align-center mb-4">
        <span class="font-weight-semibold text-base text--primary">Nieuwe klas toevoegen</span>
        <v-spacer></v-spacer>
        <v-btn
          icon
          small
          @click="$emit('update:is-add-new-class-sidebar-active',false)"
        >
          <v-icon size="22">
            {{ icons.mdiClose }}
          </v-icon>
        </v-btn>
      </div>

      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          @submit.prevent="onSubmit"
        >
          <!-- name -->
          <v-text-field
            v-model="classData.name"
            outlined
            dense
            :rules="[validators.required]"
            label="Naam"
            placeholder=""
            hide-details="auto"
            class="mb-6"
          ></v-text-field>

          <v-btn
            color="primary"
            class="me-3"
            type="submit"
          >
            Toevoegen
          </v-btn>
          <v-btn
            color="secondary"
            outlined
            type="reset"
            @click="resetclassData"
          >
            Annuleren
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import store from '@/store'
import { emailValidator, required } from '@core/utils/validation'
import { mdiClose } from '@mdi/js'
import { ref } from '@vue/composition-api'

export default {
  model: {
    prop: 'isAddNewUserSidebarActive',
    event: 'update:is-add-new-class-sidebar-active',
  },
  props: {
    isAddNewUserSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    const blankClassData = {
      name: '',
    }

    const valid = ref(false)
    const form = ref(null)

    const validate = () => {
      form.value.validate()
    }

    const resetForm = () => {
      form.value.reset()
    }

    const classData = ref(JSON.parse(JSON.stringify(blankClassData)))
    const resetclassData = () => {
      classData.value = JSON.parse(JSON.stringify(blankClassData))
      resetForm()
      emit('update:is-add-new-class-sidebar-active', false)
    }

    const onSubmit = () => {
      if (valid.value) {
        // Opslaan & sluiten
        store.dispatch('app-class/addClass', classData.value).then(response => {
          emit('refetch-data')
          emit('update:is-add-new-class-sidebar-active', false)
        })

        resetclassData()
      } else {
        validate()
      }
    }

    return {
      resetclassData,
      form,
      onSubmit,
      classData,
      valid,
      validate,

      // validation
      validators: { required, emailValidator },
      icons: {
        mdiClose,
      },
    }
  },
}
</script>
